<template>
<div class="page_set page">
    <div class="list erji">
        <div class="item bind">
            <div class="bind_card" @click="bindCard">
                <span class="tag_add">+</span>
                <span class="">绑定新卡</span>
            </div>
        </div>
		<!-- 卡列表 -->
		<van-tabs v-model="type" swipe-threshold="6" @click="bindChange">
			<van-tab title="平台充值卡" :name="1"></van-tab>
			<van-tab title="园区充值卡" :name="2"></van-tab>
		</van-tabs>
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
			<div class="cardwrap">
				<div class="item idcard" v-for="card in cardList" :key="card.id">
					<div class="card">
						<div class="card_number">ID:{{card.number}}</div>
						<div class="card_cash">余额：¥{{card.reset_money}}</div>
					</div>
					<div class="jilu" @click="record(card)">使用记录</div>
				</div>
			</div>
		</van-list>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "set-card",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isClient: false, //是否在iOSAndroid客户端内显示
            token: null,
			cardList: [],
			type: 1, // 充值卡类型 1 平台卡 2园区卡
			loading: true,
			finished: false,
			pages: {
				page: 1,
				size: 10
			}
        };
    },
    created: function () {

    },
    mounted: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                var memberParams = {
                    'data': {
                        'forceLogin': 1,
                    }
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    
                })
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData()
        }
    },
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '充值卡',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
        },
        getData() {
            var params = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
			}
			if(this.type == 1){
				this.$api.my.cardList(params).then(res => {
					if (res.code == 200) {
						var newList = [] 
						var list = res.result.list
						if(list.length != 0){
							for (let i = 0; i < res.result.list.length; i++) {
								const old = res.result.list[i];
								newList.push(old);
								// 此页要展示全部的
								// if (old.reset_money > 0) {
								// 	newList.push(old)
								// }
							}
							this.cardList = this.cardList.concat(newList)
							this.pages.page++
							this.loading = false
						}else{
							this.finished = true
						}
					
					} else {
						this.finished = true
						this.$toast(res.message)
					}
				})
			}else if(this.type == 2){
				this.$api.my.parkCardList(params).then(res => {
					if (res.code == 200) {
						var newList = []
						var list = res.result
						if(list.length != 0){
							for (let i = 0; i < list.length; i++) {
								const old = list[i];
								newList.push(old);
								// 此页要展示全部的
								// if (old.reset_money > 0) {
								// 	newList.push(old)
								// }
							}
							this.cardList = this.cardList.concat(newList)
							this.pages.page ++
							this.loading = false
						}else{
							this.finished = true
						}
						
					} else {
						this.finished = true
						this.$toast(res.message)
					}
				})
			}
            
        },
		// 绑定新卡
		bindCard(){
			this.$router.push({
				path: '/set/biandcard'
			})
		},
		// 使用记录
		record(card){
			this.$router.push({
				path: '/set/cardrecord',
				query: {
					card_id: card.id,
					type: this.type
				}
			})
		},
		// 切换tab
		bindChange(){
			var that = this
			that.pages.page = 1
			that.cardList = [];
			that.loading = true;
			that.finished = false;
			that.getData()
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
